export default {
  D1: {
    sv: [
      { uid: 3, type: "tf", label: "Ditt förnamn", model: "fname" },
      { uid: 4, type: "tf", label: "Ditt efternamn", model: "lname" },
      {
        uid: 2,
        type: "tf+tf",
        labels: ["Arbetsplats (Om du inte jobbar, skriv X i rutan)", "Avdelning"],
        models: ["arbetsplats", "avdelning"]
      },
      {
        uid: 5,
        type: "email",
        label: "Din e-postadress",
        model: "email"
      },
      /*{
        uid: 10,
        type: "extraEmail",
        text:
          "Klicka på plustecknet för att lägga till ytterligare e-postadresser",
        label: "E-post",
        model: "extraEmail"
      },*/
      {
        uid: "adszcxvz",
        type: "langSelect",
        text: "Vilket språk vill du bedöma?",
        label: "Profil Språk",
        model: "profileLang"
      }
    ],
    en: [
      { uid: 3, type: "tf", label: "Your first name", model: "fname" },
      { uid: 4, type: "tf", label: "Your last name", model: "lname" },
      {
        uid: 2,
        type: "tf+tf",
        labels: ["Workplace (If you don´t work, write X in the box.)", "Department"],
        models: ["arbetsplats", "avdelning"]
      },
      {
        uid: 5,
        type: "email",
        label: "Your email address",
        model: "email"
      },
      /*{
        uid: 10,
        type: "extraEmail",
        text: "Click plus icon to add additional email addresses",
        label: "Email",
        model: "extraEmail"
      },*/
      {
        uid: "adszcxvz",
        type: "langSelect",
        text: " What language would you like to assess?",
        label: "Profile language",
        model: "profileLang"
      }
    ],
    ar: [
      { uid: 32, type: "tf", label: "Your first name / اسمك الأول", model: "fname" },
      { uid: 44, type: "tf", label: "Your last name / اسم العائلة", model: "lname" },
      {
        uid: 21,
        type: "tf+tf",
        labels: ["Workplace / في الخانة X مكان العمل / إذا لم يكن يوجد لديك عمل ضع علامة ", "Department / القسم"],
        models: ["arbetsplats", "avdelning"]
      },
      {
        uid: 52,
        type: "email",
        label: "Your email address / عنوان بريدك الالكتروني",
        model: "email"
      },
      /*
        uid: 105,
        type: "extraEmail",
        text: "Click plus icon to add additional email addresses",
        label: "Email",
        model: "extraEmail"
      },*/
      {
        uid: "adsfdgszcxvz",
        type: "langSelect",
        text: "What language would you like to assess? / ما هي اللغة التي تريد عمل تقييم بشأنها؟",
        label: "Profile language",
        model: "profileLang"
      }
    ]
  },
  D3: {
    sv: [
      {
        id: 1,
        type: "tf",
        text: "",
        label: "Tjänst som ni tar fram en språkprofil för",
        model: "tjänst"
      },
      {
        uid: 213213,
        type: "tf+tf",
        labels: ["Arbetsplats", "Avdelning"],
        models: ["arbetsplats", "avdelning"]
      },
      { id: 3, type: "tf", label: "Ditt förnamn", model: "fname" },
      { id: 4, type: "tf", label: "Ditt efternamn", model: "lname" },
      { id: 5, type: "email", label: "E-post", model: "email" },
      {
        id: 6,
        type: "multiLangSelect",
        text:
          "Vilket eller vilka språk är nödvändiga för att utföra arbetsuppgifterna i denna tjänst?",
        label: "Språk",
        model: "necessarylangs"
      },
      {
        id: 7,
        type: "multiLangSelect",
        text: "Vilka ytterligare språk är användbara i denna tjänst?",
        label: "Språk",
        model: "usefulllangs"
      },
      {
        id: 8,
        type: "langSelect",
        text: "Vilket språk vill ni ta fram en profil för?",
        label: "Språk",
        model: "profileLang"
      }
    ],
    en: [
      {
        id: 1,
        type: "tf",
        text: "",
        label: "",
        model: "tjänst"
      },
      {
        uid: 213213,
        type: "tf+tf",
        labels: ["Workplace", "Department"],
        models: ["arbetsplats", "avdelning"]
      },
      { id: 3, type: "tf", label: "Your first name", model: "fname" },
      { id: 4, type: "tf", label: "Your last name", model: "lname" },
      { id: 5, type: "email", label: "Email", model: "email" },
      {
        id: 6,
        type: "multiLangSelect",
        text: "What languages are necessary in this job?",
        label: "Språk",
        model: "necessarylangs"
      },
      {
        id: 7,
        type: "multiLangSelect",
        text: "What other languages are necessary in this job?",
        label: "Språk",
        model: "usefulllangs"
      },
      {
        id: 8,
        type: "langSelect",
        text: "Vilket språk vill ni ta fram en profil för?",
        label: "Språk",
        model: "profileLang"
      }
    ],
    ar: [
      {
        id: 12,
        type: "tf",
        text: "",
        label: "",
        model: "tjänst"
      },
      {
        uid: 13213,
        type: "tf+tf",
        labels: ["Workplace", "Department"],
        models: ["arbetsplats", "avdelning"]
      },
      { id: 3224, type: "tf", label: "Your first name / اسمك الأول", model: "fname" },
      { id: 451, type: "tf", label: "Your last name / اسم العائلة", model: "lname" },
      { id: 521, type: "email", label: "Your email / عنوان بريدك الالكتروني", model: "email" },
      {
        id: 62,
        type: "multiLangSelect",
        text: "What languages are necessary in this job?",
        label: "Språk",
        model: "necessarylangs"
      },
      {
        id: 74,
        type: "multiLangSelect",
        text: "What other languages are necessary in this job?",
        label: "Språk",
        model: "usefulllangs"
      },
      {
        id: 84,
        type: "langSelect",
        text: "What language would you like to assess? / ما هي اللغات التي تريد عمل تقييم بشأنها؟",
        label: "Språk",
        model: "profileLang"
      }
    ]
  },
  part: {
    D1: {
      sv: {
        text: "Vilken kommunikation vill du bedöma?",
        items: [
          { text: "Både muntlig och skriftlig kommunikation", value: "both" },
          { text: "Endast muntlig kommunikation", value: "oral" },
          { text: "Endast skriftlig Kommunikation", value: "writing" }
        ]
      },
      en: {
        text: "What communication would you like to assess?",
        items: [
          { text: "Both oral and written communication", value: "both" },
          { text: "Only oral communication", value: "oral" },
          { text: "Only written communication", value: "writing" }
        ]
      },
      ar: {
        text: "What communication would you like to assess? / ما هو شكل التواصل الذي تريد تقييمه؟",
        items: [
          { text: "محادثة شفوية وتحريرية", value: "both" },
          { text: "فقط محادثة شفوية", value: "oral" },
          { text: "فقط محادثة تحريرية", value: "writing" }
        ]
      }
    },
    D3: {
      sv: {
        text: "Vilken kommunikation vill ni bedöma?",
        items: [
          { text: "Både muntlig och skriftlig kommunikation", value: "both" },
          { text: "Endast muntlig kommunikation", value: "oral" },
          { text: "Endast skriftlig Kommunikation", value: "writing" }
        ]
      },
      en: {
        text: "What communication would you like to assess?",
        items: [
          { text: "Both oral and written communication", value: "both" },
          { text: "Only oral communication", value: "oral" },
          { text: "Only written communication", value: "writing" }
        ]
      },
      ar: {
        text: "What communication would you like to assess? / ما هو شكل التواصل الذي تريد تقييمه؟",
        items: [
          { text: "محادثة شفوية وتحريرية", value: "both" },
          { text: "فقط محادثة شفوية", value: "oral" },
          { text: "فقط محادثة تحريرية", value: "writing" }
        ]
      }
    }
  }
};
